/* SV Wishlist: saved on this device, with the exact options picked. © Seery-Us Visionz, all rights reserved. */
(function () {
  var KEY = 'svWishlist.v1';
  var HEART = '<svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.4.7-1.2 2.2-2.4 4.3-2.4 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z"/></svg>';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} paint(); }
  function keyOf(i) { return i.k || (i.h + '|' + (i.v || '') + '|' + JSON.stringify(i.p || {}) + '|' + (i.a || []).map(function (a) { return a.variantId; }).join('.')); }
  function hasProduct(h) { return read().some(function (i) { return i.h === h; }); }
  function hasKey(k) { return read().some(function (i) { return keyOf(i) === k; }); }
  function add(item) { item.k = keyOf(item); var l = read().filter(function (i) { return keyOf(i) !== item.k; }); item.t = Date.now(); l.unshift(item); write(l); }
  function removeKey(k) { write(read().filter(function (i) { return keyOf(i) !== k; })); }
  function removeProduct(h) { write(read().filter(function (i) { return i.h !== h; })); }
  function handleFrom(href) { var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function money(c) { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; try { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); } catch (e) { return '$' + (c / 100).toFixed(2); } }
  window.SVWish = { read: read, add: add, removeKey: removeKey, removeProduct: removeProduct, keyOf: keyOf, hasProduct: hasProduct, money: money,
    remove: function (h) { removeProduct(h); }, has: hasProduct };

  var pdpForm = null;
  function pdpItem() {
    var p = window.SVW_PRODUCT; if (!p || !pdpForm) return null;
    var fd; try { fd = new FormData(pdpForm); } catch (e) { return null; }
    var v = fd.get('id') ? String(fd.get('id')) : '';
    var props = {};
    fd.forEach(function (val, name) {
      var m = name.match(/^properties\[(.+)\]$/);
      if (m && typeof val === 'string' && val.trim() !== '') props[m[1]] = val;
    });
    var vt = (p.vars && p.vars[v]) || '';
    return { h: p.h, n: p.n, i: p.i, v: v, vt: vt === 'Default Title' ? '' : vt, p: props };
  }

  function paint() {
    var n = read().length;
    document.querySelectorAll('[data-svw-count]').forEach(function (el) { if (el.textContent !== String(n)) el.textContent = n; if (el.hidden !== (n === 0)) el.hidden = n === 0; });
    document.querySelectorAll('.svw-card[data-svw-h]').forEach(function (b) {
      var on = hasProduct(b.getAttribute('data-svw-h'));
      if (b.classList.contains('is-on') !== on) { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    });
    var pb = document.querySelector('.svw-pdp');
    if (pb) {
      var it = pdpItem(), on = !!(it && hasKey(keyOf(it)));
      if (pb.classList.contains('is-on') !== on) { pb.classList.toggle('is-on', on); pb.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      var lab = pb.querySelector('[data-svw-label]');
      var txt = on ? 'Saved to wishlist' : (it && it.vt ? 'Save these options to wishlist' : 'Save to wishlist'); if (lab && lab.textContent !== txt) lab.textContent = txt;
    }
    document.dispatchEvent(new CustomEvent('svwish:change'));
  }

  function headerIcon() {
    if (document.querySelector('.svw-header')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist'; a.className = 'svw-header'; a.setAttribute('aria-label', 'My wishlist');
    a.innerHTML = HEART + '<span class="svw-count" data-svw-count hidden>0</span>';
    var cart = icons.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (cart) icons.insertBefore(a, cart); else icons.appendChild(a);
  }

  function cardHearts() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.svw-card')) return;
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      var h = handleFrom(link.getAttribute('href')); if (!h) return;
      var img = card.querySelector('img');
      var title = (card.querySelector('.card__heading') || link).textContent.trim();
      var host = card.querySelector('.card__inner') || card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'svw-card'; b.setAttribute('data-svw-h', h); b.setAttribute('aria-label', 'Save ' + title + ' to wishlist');
      b.innerHTML = HEART;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (hasProduct(h)) removeProduct(h); else add({ h: h, n: title, i: img ? (img.currentSrc || img.src) : '' });
      });
      host.appendChild(b);
    });
  }

  function productButton() {
    var p = window.SVW_PRODUCT;
    if (!p || document.querySelector('.svw-pdp')) return;
    var form = null;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) { if (!form && !f.closest('.card-wrapper') && f.querySelector('[name="add"], [type="submit"]')) form = f; });
    if (!form) return;
    pdpForm = form;
    var btn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'svw-pdp';
    b.innerHTML = HEART + '<span data-svw-label>Save to wishlist</span>';
    b.addEventListener('click', function () { var it = pdpItem(); if (!it) return; if (hasKey(keyOf(it))) removeKey(keyOf(it)); else add(it); });
    (btn.parentNode || form).insertBefore(b, btn.nextSibling);
    document.addEventListener('change', function () { setTimeout(paint, 50); }, true);
    document.addEventListener('input', function () { clearTimeout(window.__svwI); window.__svwI = setTimeout(paint, 300); }, true);
  }


  /* Cart page: "Move to wishlist" next to "Save for later", and on each Saved for later item. */
  function cleanProps(p) { var o = {}; Object.keys(p || {}).forEach(function (k) { var v = p[k]; if (v !== null && v !== '' && typeof v !== 'object') o[k] = String(v); }); return o; }
  function addonsFor(cart, it) {
    var kids = cart.items.filter(function (c) { return c.parent_relationship && c.parent_relationship.parent_key === it.key; });
    var loose = cart.items.filter(function (c) { return !c.parent_relationship && c.properties && c.properties._sv_per_unit && c.properties.For === it.product_title; });
    return kids.concat(kids.length ? [] : loose).filter(function (c) { return c.properties && c.properties._sv_per_unit; });
  }
  function wishFromCart(it, cart) {
    var adds = cart ? addonsFor(cart, it) : [];
    return { h: it.handle, n: it.product_title, i: it.image ? (it.image.indexOf('//') === 0 ? 'https:' + it.image : it.image) : '', v: String(it.variant_id), vt: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '', p: cleanProps(it.properties),
      a: adds.map(function (a) { return { variantId: a.variant_id, per: parseInt(a.properties._sv_per_unit, 10) || 1, label: a.properties.Option || a.variant_title || a.product_title, handle: a.handle, properties: { For: a.properties.For, Option: a.properties.Option } }; }) };
  }
  function cartHearts() {
    var wrap = document.getElementById('main-cart-items'); if (!wrap) return;
    if (!wrap.querySelector('[id^="CartItem-"]:not([data-svw-done])')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      cart.items.forEach(function (it, i) {
        var row = document.getElementById('CartItem-' + (i + 1)); if (!row || row.getAttribute('data-svw-done')) return;
        row.setAttribute('data-svw-done', '1');
        var p = it.properties || {};
        if (it.parent_relationship || p._sv_per_unit || /routeins|^tip$/i.test(it.handle || '')) return;
        var cell = row.querySelector('.cart-item__details'); if (!cell) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'svw-move'; b.innerHTML = HEART + '<span>Move to wishlist</span>';
        b.addEventListener('click', function () {
          b.disabled = true; b.querySelector('span').textContent = 'Moving...';
          add(wishFromCart(it, cart));
          var updates = {}; updates[it.key] = 0;
          addonsFor(cart, it).forEach(function (c) { updates[c.key] = 0; });
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function () { location.reload(); }, function () { b.disabled = false; b.querySelector('span').textContent = 'Move to wishlist'; });
        });
        cell.appendChild(b);
      });
    }).catch(function () {});
  }
  function savedHearts() {
    document.querySelectorAll('[data-sv-saved]').forEach(function (box) {
      var store; try { store = JSON.parse(localStorage.getItem('sv_saved_for_later_v1') || '[]'); } catch (e) { store = []; }
      box.querySelectorAll('.sv-ro-line').forEach(function (li, i) {
        var it = store[i]; if (!it || li.querySelector('.svw-move')) return;
        var acts = li.querySelector('.sv-ro-actions'); if (!acts) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'svw-move'; b.innerHTML = HEART + '<span>Move to wishlist</span>';
        b.addEventListener('click', function () {
          add({ h: it.handle, n: it.title, i: it.image ? (String(it.image).indexOf('//') === 0 ? 'https:' + it.image : it.image) : '', v: String(it.variantId), vt: it.variantTitle && it.variantTitle !== 'Default Title' ? it.variantTitle : '', p: cleanProps(it.properties), a: it.addons || [] });
          if (window.SVReorder && SVReorder.Store) SVReorder.Store.remove([it.uid]);
        });
        acts.insertBefore(b, acts.firstChild);
      });
    });
  }

  /* Recently viewed: remember the last 12 products looked at on this device. */
  function trackRecent() {
    var p = window.SVW_PRODUCT; if (!p || window.__svwRec) return; window.__svwRec = 1;
    try { var l = JSON.parse(localStorage.getItem('svRecent.v1') || '[]').filter(function (x) { return x.h !== p.h; }); l.unshift({ h: p.h, n: p.n, i: p.i, t: Date.now() }); localStorage.setItem('svRecent.v1', JSON.stringify(l.slice(0, 12))); } catch (e) {}
  }
  function run() { trackRecent(); headerIcon(); cardHearts(); productButton(); cartHearts(); savedHearts(); paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { clearTimeout(window.__svwT); window.__svwT = setTimeout(function () { headerIcon(); cardHearts(); productButton(); cartHearts(); savedHearts(); paint(); }, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
})();
